import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link, useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function PharmProfit(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [addedby, setAddedby] = useState({ username: '' });
  const [mode, setMode] = useState({ mode: '' });
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState([]);
  const [combinedData, setcombinedData] = useState([]);
  const [viewPharmData, setViewPharmData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleUser = (event) => {
      setAddedby({
        ...addedby,
        username: event.target.value
      });
    };
    const handleMode = (event) => {
      setMode({
        ...mode,
        mode: event.target.value
      });
    };
  useEffect(() => {
    try {
        axios.get(`${baseUrl}user-search/`)
        .then(function (response) {
            setUserData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
      fetchData();

  }, [startDate, endDate, addedby, mode]);
  useEffect(() => {
      if (combinedData.length > 0) {
        setRows(combinedData);
      }
  }, [combinedData]);



  async function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}all-pharm-sale/?start_date=${startDateString}&end_date=${endDateString}&addedby=${addedby.username}&mode=${mode.mode}&status=1`;

  try {
    const response = await axios.get(url);
    const filteredData = response.data.filter(item => item.mode !== 'Indent');
    setcombinedData(filteredData);
    setIsLoading(false);
  } catch (error) {
    console.log(error);
    setIsLoading(false);
  }
}

useEffect(() => {
      if (combinedData.length > 0) {
       fetchPharmData();
      }
  }, [combinedData]);

async function fetchPharmData() {
  try {
    const productIds = combinedData.reduce((ids, row) => {
      const products = row.product.split(',').map(item => item.trim());
      return [...ids, ...products];
    }, []);

    const responses = await Promise.all(productIds.map(id => axios.get(`${baseUrl}update-indent-use/${id}/`)));

    const updatedPharmData = responses.map(response => response.data);
    const updatedCombinedData = combinedData.map(row => {
      const products = row.product.split(',').map(item => item.trim());
      const updatedProducts = products.map(product => {
        const updatedData = updatedPharmData.find(data => data.product.product === product);
        return updatedData ? { ...updatedData.product, cgst: updatedData.product.cgst } : product;
      });
      return { ...row, product: updatedProducts.join(', ') };
    });

    setViewPharmData(updatedPharmData);
    setRows(updatedCombinedData);
  } catch (error) {
    console.log(error);
  }
}
const totalMrp = rows.reduce((total, row) => {
  const productNames = row.product.split(',').map(item => item.trim());
  const qtys = row.qty.split(',').map(item => item.trim());
  let mrpAmount = 0;

  productNames.forEach((productName, index) => {
    const productData = viewPharmData.find(data => data.id === parseInt(productName));
    if (productData && productData.product.uamount && qtys[index]) {
      const mrp = parseFloat(productData.product.uamount);
      const qty = parseInt(qtys[index]);
      mrpAmount += mrp * qty;
    }
  });

  return total + mrpAmount;
}, 0);

const totalPPrice = rows.reduce((total, row) => {
  const productNames = row.product.split(',').map(item => item.trim());
  const qtys = row.qty.split(',').map(item => item.trim());
  let ppriceAmount = 0;

  productNames.forEach((productName, index) => {
    const productData = viewPharmData.find(data => data.id === parseInt(productName));
    if (productData && productData.product.pprice) {
      const pprice = parseFloat(productData.product.pprice);
      const pack = parseFloat(productData.product.pack);
      const qty = parseInt(qtys[index]);
      ppriceAmount += ((pprice / pack) * qty);
    }
  });

  return total + ppriceAmount;
}, 0);
const columns = [
  { field: 'mrp', headerName: 'Total Mrp', width: 120 },
  { field: 'pprice', headerName: 'Total Purchase Price', width: 150 },
  { field: 'totalPaid', headerName: 'Total Paid', width: 100 },
];


const summaryRow = {
  id: 'summary',
  mrp: totalMrp.toFixed(2),
  pprice: totalPPrice.toFixed(2),
  totalPaid: rows.length > 0 ? rows.reduce((total, row) => total + parseFloat(row.paid), 0).toFixed(2) : '',
};

  const data = [summaryRow];

  const today = new Date();

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i>  Pharmacy Sales Statement  </h3>
      <div className="row">
        <div className="col-md-4">
            <label className="control-label">Select Date</label>
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>


      </div>

  {!isLoading && combinedData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={data}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
              footer: () => (
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                  <div>Total MRP: {totalMrp.toFixed(2)}</div>
                  <div>Total Purchase Price: {totalPPrice.toFixed(2)}</div>
                  <div>Total Profit : {(totalMrp - totalPPrice).toFixed(2)}</div>
                </div>
              ),
            }}
            autoHeight
          />
        </div>
      ) : (
        <></>
      )}
    </section>
  )
}

export default PharmProfit;
